import type { HuntTimeSlot, HuntType } from './hunt-type'

export type TimeBlockPeriod = Exclude<HuntTimeSlot, 'night'>

export type TimeBlock = {
  id: string
  orgId: string
  huntType: HuntType
  name: string
  startTime: string
  endTime: string
  timePeriod: TimeBlockPeriod
  enabled: boolean
  displayOrder: number
}

export type TimeBlockSheetMode = 'create' | 'edit'

export type TimeBlockPeriodOption = {
  value: TimeBlockPeriod
  label: string
}

export type TimeBlockFormValues = {
  huntType: HuntType
  name: string
  startTime: string
  endTime: string
  timePeriod: TimeBlockPeriod
  enabled: boolean
  displayOrder?: number
}

export const TIME_BLOCK_PERIODS: TimeBlockPeriod[] = ['am', 'midday', 'pm', 'all-day']

export const TIME_BLOCK_PERIOD_LABELS: Record<TimeBlockPeriod, string> = {
  am: 'AM',
  midday: 'Midday',
  pm: 'PM',
  'all-day': 'All Day',
}

export const TIME_BLOCK_PERIOD_OPTIONS: TimeBlockPeriodOption[] =
  TIME_BLOCK_PERIODS.map((value) => ({
    value,
    label: TIME_BLOCK_PERIOD_LABELS[value],
  }))
